
export default {
  name: 'AgentsListSearchPanel',

  props: {
    projectUuid: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      isSubmitForm: false,
      searchParams: {
        name: '',
        nr_tel: '',
        type: '',
        active: true,
      },
    };
  },

  watch: {
    searchParams: {
      handler(newVal) {
        this.$emit('changeFilterBy', newVal);
      },
      deep: true,
    },
  },

  methods: {
    async clearSearchParams() {
      this.searchParams.name = '';
      this.searchParams.nr_tel = '';
      this.searchParams.type = '';
      this.searchParams.active = true;
    },
  },
};
